import { default as aboutqpaaJ53rNYMeta } from "/home/runner/work/website/website/app/pages/about.vue?macro=true";
import { default as careers87G9REdlA2Meta } from "/home/runner/work/website/website/app/pages/careers.vue?macro=true";
import { default as contact0HGtAvBqvzMeta } from "/home/runner/work/website/website/app/pages/contact.vue?macro=true";
import { default as indexGl7VTFBJ10Meta } from "/home/runner/work/website/website/app/pages/index.vue?macro=true";
import { default as industriesKz3Zj292wKMeta } from "/home/runner/work/website/website/app/pages/industries.vue?macro=true";
import { default as privacy_45policyeQFDXPbB0OMeta } from "/home/runner/work/website/website/app/pages/privacy-policy.vue?macro=true";
import { default as _91development_93a7A4KB8SZTMeta } from "/home/runner/work/website/website/app/pages/services/[development].vue?macro=true";
import { default as consultingjEUEodqFV9Meta } from "/home/runner/work/website/website/app/pages/services/consulting.vue?macro=true";
import { default as designzwS9wY7b4EMeta } from "/home/runner/work/website/website/app/pages/services/design.vue?macro=true";
import { default as showcasehTzalNYpFpMeta } from "/home/runner/work/website/website/app/pages/showcase.vue?macro=true";
import { default as component_45stubXrNKY58qauMeta } from "/home/runner/work/website/website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubXrNKY58qau } from "/home/runner/work/website/website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/home/runner/work/website/website/app/pages/about.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/home/runner/work/website/website/app/pages/careers.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/runner/work/website/website/app/pages/contact.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/website/website/app/pages/index.vue")
  },
  {
    name: "industries",
    path: "/industries",
    component: () => import("/home/runner/work/website/website/app/pages/industries.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/website/website/app/pages/privacy-policy.vue")
  },
  {
    name: "services-development",
    path: "/services/:development()",
    component: () => import("/home/runner/work/website/website/app/pages/services/[development].vue")
  },
  {
    name: "services-consulting",
    path: "/services/consulting",
    component: () => import("/home/runner/work/website/website/app/pages/services/consulting.vue")
  },
  {
    name: "services-design",
    path: "/services/design",
    component: () => import("/home/runner/work/website/website/app/pages/services/design.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    component: () => import("/home/runner/work/website/website/app/pages/showcase.vue")
  },
  {
    name: component_45stubXrNKY58qauMeta?.name,
    path: "/services/",
    component: component_45stubXrNKY58qau
  }
]